import PropTypes from 'prop-types'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  list: PropTypes.object,
  entity: PropTypes.object,
}

export default propTypes
